import { createFileRoute, redirect } from "@tanstack/react-router";
import { useStore } from "zustand";
import { useVisibleOpsTools } from "@/hooks/use-ops-access";
import { opsUiStore } from "@/lib/stores/ops-ui-store";
import type { OperationsRoutes } from "@/operations-routes";

/**
 * Deep-link shim. `/operations/<tool>` opens that tool's tab in the ops store
 * (if the user may see it), then redirects to the canonical `/operations`.
 * Mirrors the `/app/$channelId` shim. Runs inside the `/operations` guard, so
 * roles are already loaded when this renders.
 */

const SLUG_TO_TYPE: Record<string, OperationsRoutes["type"]> = {
	dashboard: "operationsDashboard",
	users: "operationsUsers",
	channels: "operationsChannels",
	attendance: "operationsAttendance",
	scheduler: "operationsStudioScheduler",
	roles: "operationsRoles",
	documents: "operationsDocuments",
	invites: "operationsInvites",
};

export const Route = createFileRoute("/operations/$tool/")({
	component: ShimComponent,
});

function ShimComponent() {
	const { tool } = Route.useParams();
	const navigate = useStore(opsUiStore, (s) => s.navigate);
	const visible = useVisibleOpsTools();

	const type = SLUG_TO_TYPE[tool];
	if (type && visible.some((t) => t.type === type)) {
		navigate({ type });
	}
	throw redirect({ to: "/operations" });
}
